import { instanceAxios, instanceAxiosSecurity,instanceAxiosCuadrilla,instanceAxiosCheckList } from "./instanceAxios"


const rtkAxiosBaseQuery = async ({url, method = 'GET', ...restArgs}) => {
  try {
    const {data: dataResult} = await instanceAxios.request({url, method, ...restArgs})
    return {data: dataResult}
  } catch (axiosError) {
    const err = axiosError
    return {error: {status: err.response?.status, data: err.response?.data}}
  }
}

const rtkAxiosBaseSecurityQuery = async ({url, method = 'GET', ...restArgs}) => {
  try {
    const {data: dataResult} = await instanceAxiosSecurity.request({url, method, ...restArgs})
    return {data: dataResult}
  } catch (axiosError) {
    const err = axiosError
    return {error: {status: err.response?.status, data: err.response?.data}}
  }
}

const rtkAxiosBaseCuadrillaQuery = async ({url, method = 'GET', ...restArgs}) => {
  try {
    const {data: dataResult} = await instanceAxiosCuadrilla.request({url, method, ...restArgs})
    return {data: dataResult}
  } catch (axiosError) {
    const err = axiosError
    return {error: {status: err.response?.status, data: err.response?.data}}
  }
}

const rtkAxiosBaseCheckListQuery = async ({url, method = 'GET', ...restArgs}) => {
  
  try {
    const {data: dataResult} = await instanceAxiosCheckList.request({url, method, ...restArgs})
    return {data: dataResult}
  } catch (axiosError) {
    const err = axiosError
    return {error: {status: err.response?.status, data: err.response?.data}}
  }
}
export  {rtkAxiosBaseQuery, rtkAxiosBaseSecurityQuery,rtkAxiosBaseCuadrillaQuery,rtkAxiosBaseCheckListQuery}
